import { render, staticRenderFns } from "./one-year.vue?vue&type=template&id=242b9c6e&scoped=true"
import script from "./one-year.vue?vue&type=script&lang=js"
export * from "./one-year.vue?vue&type=script&lang=js"
import style0 from "./one-year.vue?vue&type=style&index=0&id=242b9c6e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b9c6e",
  null
  
)

export default component.exports